import React from "react";

import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import ReactDatePicker from "react-datepicker";
import { ClipLoader } from "react-spinners";
import { ComponentHeader, DashboardCard } from "../../modules";
import { getReports, sendReport } from "../../redux/action/analytics";
import QuantityOverTime from "./components/QuantityOverTime";
import ReportsPickupHistory from "./components/ReportsPickupHistory";
import VitalSustainabilityMetrics from "./components/VitalSustainabilityMetrics";
import DashboardBox from "../dashboard/components/DashboardBox";
import BestPerformers from "./components/BestPerformers";
import { useMediaQuery } from "react-responsive";

// Default range: the previous calendar month.
const firstDayOfLastMonth = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth() - 1, 1);
};
const lastDayOfLastMonth = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 0);
};

function Reports() {
  const dispatch = useDispatch();
  const isTablet = useMediaQuery({ query: "(max-width: 1224px)" });
  const { reports } = useSelector((state) => state.analytics);
  const { account } = useSelector((state) => state.account);

  const [exportOpen, setExportOpen] = useState(false);
  const [startDate, setStartDate] = useState(firstDayOfLastMonth());
  const [endDate, setEndDate] = useState(lastDayOfLastMonth());
  const [sending, setSending] = useState(false);

  useEffect(() => {
    dispatch(getReports());
  }, [dispatch]);

  const handleSendReport = async () => {
    if (!startDate || !endDate) return;
    if (startDate > endDate) return;
    setSending(true);
    const ok = await dispatch(
      sendReport(startDate.toISOString(), endDate.toISOString())
    );
    setSending(false);
    if (ok) setExportOpen(false);
  };

  return (
    <div className="p-1">
      <div className="component-haeder flex space-between">
        <h4>Overall Reports & Analytics </h4>

        <button className="btn" onClick={() => setExportOpen(true)}>
          Export
        </button>
      </div>

      <Modal
        open={exportOpen}
        onClose={() => setExportOpen(false)}
        center
        styles={{ modal: { borderRadius: "10px", width: 380, maxWidth: "94%" } }}
      >
        <h5 className="bold" style={{ marginTop: 0 }}>
          Export Activity Report
        </h5>
        <p style={{ color: "#6b7280", fontSize: 13, marginTop: 4 }}>
          Choose a date range. The report will be generated and emailed to you
          {account?.email ? ` (${account.email})` : ""}.
        </p>

        <div className="flex column" style={{ gap: 4, marginTop: 12 }}>
          <label style={{ fontSize: 13, fontWeight: 600 }}>Start date</label>
          <ReactDatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
            dateFormat="MMM d, yyyy"
            className="browser-default"
          />
        </div>

        <div className="flex column" style={{ gap: 4, marginTop: 12 }}>
          <label style={{ fontSize: 13, fontWeight: 600 }}>End date</label>
          <ReactDatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={new Date()}
            dateFormat="MMM d, yyyy"
            className="browser-default"
          />
        </div>

        <div
          className="flex space-between"
          style={{ gap: 10, marginTop: 20 }}
        >
          <button
            className="modal-button white cercle-purple-text"
            onClick={() => setExportOpen(false)}
            disabled={sending}
          >
            Cancel
          </button>
          <button
            className="modal-button cercle-purple white-text"
            onClick={handleSendReport}
            disabled={sending}
          >
            {sending ? <ClipLoader size={16} color="#fff" /> : "Send to my email"}
          </button>
        </div>
      </Modal>

      <div
        style={{ gap: "1.5rem" }}
        className={isTablet ? "flex-wrap" : "flex flex-wrap"}
      >
        <div style={{ gap: "1.5rem" }} className="flex column flex-1">
          <DashboardBox
            title="Cerclex Credits"
            amount={reports?.cercle_credits}
            desc="T&C's Apply"
            img="../images/cerclex.png"
          />

          <DashboardBox
            title="Plastic Credits"
            amount={reports?.plastic_credits}
            desc="T&C's Apply"
            img="../images/plasticCredits.svg"
          />
        </div>
        <div
          style={{ gap: "1.5rem" }}
          className={
            isTablet ? "flex column flex-1 mt-2 mb-2" : "flex column flex-1"
          }
        >
          <DashboardBox
            title="Carbon Credits"
            amount={reports?.carbon_credits}
            desc="T&C's Apply"
            img="../images/co2Credits.svg"
          />

          <DashboardBox
            title="Water Credits"
            amount="N/A"
            desc="T&C's Apply"
            img="../images/h2oCredits.svg"
          />
        </div>

        <QuantityOverTime />
      </div>

      <div className="mt-2">
        <BestPerformers />
      </div>


      <div className="mt-2">
        <ReportsPickupHistory />
      </div>

      {account.permissions.includes("read-analytics") && (
        <div className="full-width mt-1">
          <div className="mv-1 ">
            <p className="bold mb-1">Vital Sustainability Metrics</p>
          </div>

          <div style={{ gap: "1.5rem" }} className="flex flex-wrap">
            <div style={{ gap: "1.5rem" }} className="flex column flex-1">
              {/* <div style={{ gap: "1.5rem" }} className="flex"> */}
              <DashboardBox
                title="Carbon Avoided"
                amount={reports?.co2_avoided}
                desc="T&C's Apply"
                img="../images/carbonavoided.svg"
              />
            </div>
            <div style={{ gap: "1.5rem" }} className="flex column flex-1">
              <DashboardBox
                title="Energy Savings (KWH)"
                amount={reports?.energy_saved}
                desc="T&C's Apply"
                img="../images/energySavings.svg"
              />
            </div>
            <div style={{ gap: "1.5rem" }} className="flex column flex-1">
              <DashboardBox
                title="Trees Saved"
                amount={reports?.trees_saved}
                desc="T&C's Apply"
                img="../images/treesSaved.svg"
              />
            </div>
            <div style={{ gap: "1.5rem" }} className="flex column flex-1">
              <DashboardBox
                title="Water Saved (kL)"
                amount={reports?.water_saved}
                desc="T&C's Apply"
                img="../images/waterSaved.svg"
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      )}


      <div className="mt-2">
        <ReportsPickupHistory />
      </div>

      {/* {account.permissions.includes("read-analytics") && (
        <VitalSustainabilityMetrics reports={reports} />
      )} */}
    </div>
  );
}

export default Reports;
